import isDarkTheme from '_shared_/js/utils/isDarkTheme';
import { uiAPI } from './UIAPI';

/** Call after Vue's next tick, when data-theme is applied to the document. */
export function announceThemeToHost(theme: string, readerElement: Element | null): void {
    if (!theme || !readerElement) return;
    const styles = window.getComputedStyle(readerElement);
    const backgroundColor = styles.getPropertyValue('--theme-background-color').trim();
    const pageBackgroundColor = styles.getPropertyValue('--theme-background-reader').trim();
    if (!backgroundColor) {
        console.debug('[ThemeAnnouncer] no toolbar background for theme:', theme);
        return;
    }
    void uiAPI.themeChanged({
        theme,
        isDark: isDarkTheme(theme),
        backgroundColor,
        pageBackgroundColor: pageBackgroundColor || undefined,
    });
}
